export default {
  articleReadTime: {
    id: 'article_read_time',
    defaultMessage: `{count, plural,
        one {# min read}
        other {# mins read}
      }`,
  },
} as const
